import { YEAR_ADDEDIT, YEAR_WOP_LIST, YEAR_DELETE } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";

export const AddEditYearApi = (payload) => {
    return apiInstance.post(YEAR_ADDEDIT, payload, {
        headers: authHeader(),
    });
};

export const yearWopListApi = (payload) => {
    return apiInstance.post(YEAR_WOP_LIST, payload,{
        headers: authHeader(),
    });
};

export const yearDeleteApi = (payload) => {
    return apiInstance.post(YEAR_DELETE, payload, {
        headers: authHeader(),
    });
};